import React from "react";
import ExamPanel from "./ExamPanel";

const listeningImages = ["/image/speaking/1.jpg", "/image/speaking/4.jpg", "/image/speaking/5.jpg"];
const speakingImages = ["/image/speaking/3.jpg", "/image/speaking/6.jpg", "/image/speaking/7.jpg"];

const ImageStrip = ({ images }) => (
  <div className="mt-4 grid gap-3 sm:grid-cols-3">
    {images.map((src) => (
      <img
        key={src}
        className="h-32 w-full rounded-md border border-slate-200 bg-white object-contain p-2"
        src={src}
        alt=""
      />
    ))}
  </div>
);

export default function SpeakingInstructionPage() {
  return (
    <ExamPanel
      eyebrow="Speaking section"
      title="Speaking Instructions"
      instructions="Some questions require you to listen first and then record your answer clearly into the microphone."
    >
      <div className="grid gap-4 lg:grid-cols-2">
        <article className="rounded-md border border-slate-200 bg-slate-50 p-5">
          <h3 className="text-lg font-extrabold text-gray-900">Listening status</h3>
          <p className="mt-2 text-sm leading-6 text-gray-600">
            The current status shows how long you have until the audio clip starts.
            A progress bar shows the audio playback.
          </p>
          <ImageStrip images={listeningImages} />
        </article>

        <article className="rounded-md border border-slate-200 bg-slate-50 p-5">
          <h3 className="text-lg font-extrabold text-gray-900">Speaking status</h3>
          <p className="mt-2 text-sm leading-6 text-gray-600">
            Start speaking when the status changes to recording. If you remain
            silent for more than 3 seconds, recording may stop automatically.
          </p>
          <ImageStrip images={speakingImages} />
        </article>
      </div>
    </ExamPanel>
  );
}
